package com.ustadmobile.lib.util.ext

import com.ustadmobile.door.DoorSqlDatabase

actual fun DoorSqlDatabase.fixTincan() {
}